<template>
  <div id="app" ref="app" class="app">
    <Topbar ref="topbar" class="app__header"></Topbar>
    <router-view class="app__main" />
    <FAB
      @onShowModal="isOpened = true"
      v-if="isMainSupportOption.length && isMainSupportOption[0].value.status"
    />
    <UserSupport @onModalClose="closeModal" v-if="isOpened" />
  </div>
</template>

<script>
import filter from "lodash/filter";

const Topbar = () => import("@/modules/user/elements/Topbar");
const FAB = () => import("@/modules/user/elements/FAB");
const UserSupport = () => import("@/modules/user/pages/UserSupport");

export default {
  components: {
    Topbar,
    FAB,
    UserSupport
  },
  data: () => ({
    isOpened: false,
    isMainSupportOption: {}
  }),
  computed: {
    options() {
      return this.$store.state.concierge.optionsList.data;
    }
  },
  async created() {
    await this.$store.dispatch("fetchOptions", "support");

    let supportFilterMain = {
      key: "support.main"
    };
    this.isMainSupportOption = filter(this.options, supportFilterMain);
  },
  methods: {
    closeModal() {
      this.isOpened = false;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/main.scss";
.app {
  &__main {
    margin-top: 7.25rem;
  }
}

@media print {
  .print-hidden {
    display: none !important;
  }
  .app__main {
    margin-top: 0 !important;
  }
}
</style>
